import { Button } from '@context365/button'
import { Launch } from '@context365/icons'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import map from 'lodash/map'
import orderBy from 'lodash/orderBy'
import take from 'lodash/take'
import moment from 'moment'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import * as api from '~/api'
import CardButton from '~/components/CardButton'
import { getCompanyId } from '~/selectors/auth'
import WidgetBlock from './WidgetBlock'

const UpcomingEvents = () => {
  const { data: events = [] } = useQuery(
    ['upcomingEvents'],
    () => api.events.getEvents(),
    {
      select: (res) =>
        take(orderBy(res.data.result.upcomingEvents, 'startDate', 'asc'), 4),
    }
  )

  const companyId = useSelector(getCompanyId)

  const fmt1 = 'MMMM D'
  const fmt2 = 'MMMM D, YYYY'

  const getFormatedEventDate = (timezone, eventDateTime, format) => {
    const eventTimezone = isNil(timezone) ? moment.tz.guess() : timezone
    const convertedTime = moment.utc(eventDateTime).tz(eventTimezone)

    return `${convertedTime.format(format)}`
  }

  const isActiveEvent = (event) => {
    const now = moment()
    const startDate = moment(event.startDate)
    const endDate = moment(event.endDate)
    return now.isBetween(startDate, endDate, null, '[]')
  }

  const eventLink = (event) => {
    if (!event.amRegistered && event.registrationUrl)
      return event.registrationUrl
    else if (
      find(event.registeredWithCompanies, (c) => c.companyId === companyId) &&
      isActiveEvent(event)
    )
      return `/summits/${event.eventId}`
    else return '/summits'
  }

  return (
    <WidgetBlock
      headerLeft="Global Events"
      headerRight={
        <Button
          variant="link"
          as={Link}
          to="/summits"
          iconRight={<Launch />}
          style={{ padding: 0 }}
          status="secondary"
        >
          See All
        </Button>
      }
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-4">
        {isEmpty(events) ? (
          <div>No upcoming events.</div>
        ) : (
          map(events, (e) => (
            <CardButton
              href={eventLink(e)}
              target={!e.amRegistered && e.registrationUrl ? '_blank' : '_self'}
              className="shadow-6 md:shadow-none border-grey-300 md:space-y-3"
            >
              {/* <div className="type-subtitle-sm text-secondary-100">SUMMIT</div> */}
              {e.thumbnailImage && (
                <img
                  src={e.thumbnailImage}
                  alt={e.name}
                  // style={{ maxHeight: '123px' }}
                  className="block w-full h-40 object-cover object-center"
                />
              )}
              <div className="type-body-semibold-md mt-2">{e.name}</div>
              <div className="type-body-xs">
                {getFormatedEventDate(e.timeZone, e.startDate, fmt1)} -{' '}
                {getFormatedEventDate(e.timeZone, e.endDate, fmt2)}
              </div>
            </CardButton>
          ))
        )}
      </div>
    </WidgetBlock>
  )
}

export default UpcomingEvents
